export default __webpack_public_path__ + "static/media/NorthGate.c6bdc213.jpeg";